import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateCustomerLocationsQuery = (customerId: string) => {
  const queryClient = useQueryClient();
  const invalidateQuery = () => {
    queryClient.invalidateQueries({
      queryKey: [...customerQueryKey._customerLocation(customerId), 'list'],
    });
    queryClient.invalidateQueries({
      queryKey: [...customerQueryKey._customerBrokerage(customerId), 'metadata'],
    });
  };
  return invalidateQuery;
};
